import React from "react";
import IframeContainer from "components/IframeContainer";
import { FairSelectorContent } from "./FairSelectorContent";

export const FairSelector = () => {
	return <IframeContainer renderItems={() => <FairSelectorContent />} />;
};
